import { ellipsisText } from './shared-ellipsis-text-style';

export const getInfoPaneItemCopyUrlStyle = (components, { palette = {} } = {}) => ({
  contentItem: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Segoe UI',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '19px',
    marginTop: '8px',
  },
  contentName: {
    color: palette.neutralSecondary,
    marginRight: 8,
    width: 97,
  },
  contentValue: {
    color: palette.neutralPrimary,
    maxWidth: 230,
    ...ellipsisText(),
  },
  copyUrl: {
    border: 'none',
    background: 'transparent',
    fontFamily: 'Segoe UI',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    textDecorationLine: 'underline',
    color: palette.themeDarkAlt,
  },
});
